import NativeAccountPage from './NativeAccountPage';

export default function EmailVerificationPage() {
  return (
    <NativeAccountPage
      title="Email Addresses"
      description="Manage your email addresses, confirm a new address or resend a verification message."
      label="Manage Email Addresses"
      href="/accounts/email/"
    />
  );
}
